export default "__VITE_ASSET__Dj$BKprE__"